/**
 * @param {*} - Comma separated routers which must be a promise function.
 * @return {Function} - Promise function which is resolved with context data when one of the passed promise function is resolved or all are rejected.
 *                      This functin takes router context object. Integrate can passed avalilable data.
 *                      Each router can set its owned data which may helps next router. 
 * 
 * This is a composer method which takes multiple routers as arguments and invoked one by one router. 
 * Next router is invoked only if previous router is rejected.
 */
export const composeRouter = function () {
  let routers = [...arguments];

  return function (routerContext) {
    let index = 0;
    routerContext = routerContext || {};
    
    return new Promise(function (resolve, reject) {

      // Listen for abort event on signal
      routerContext.signal && routerContext.signal.addEventListener('abort', () => {
        reject({ type: 'ABORTED'});
      });

      //Invoke one by one router
      const next = function (router) {
        if (!router) {
          resolve(routerContext);
          return;
        }

        router(routerContext).then(function () {
          resolve(routerContext);
        }).catch(function () {
          if (!routerContext.signal.aborted) {
            index = index + 1;
            next(routers[index]);
          }
        });
      };

      next(routers[index]);
    });
  }
}